import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/pecuaria/cadastro/pelagem' };
/////////////////////////////////////////////////////////////////////////////////

export function createAnimalPelagemCadastro(payload) {
  return httpService.post(args, payload);
}

export function updateAnimalPelagemCadastro(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listAnimalPelagemCadastro(param) {
  return httpService.get({...args, args: param});
}

export function findAnimalPelagemCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function deleteAnimalPelagemCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

